import { styled } from 'theme'

export const Container = styled('div', {
  width: '100%',
  flexShrink: 0,
  mx: 'auto',

  variants: {
    size: {
      xs: {
        maxWidth: '$breakpoints$xs',
      },
      sm: {
        maxWidth: '$breakpoints$sm',
      },
      md: {
        maxWidth: '$breakpoints$md',
      },
      lg: {
        maxWidth: '$breakpoints$lg',
      },
      xl: {
        maxWidth: '$breakpoints$xl',
      },
      fluid: {
        maxWidth: 'none',
      },
    },
  },
  defaultVariants: {
    size: 'fluid',
  },
})
